/* istanbul ignore file */
function loadTruncationLib() {
    return import('shiitake');
}

export {loadTruncationLib};
